<template>
  <div class="homepage-features__wrapper">
    <div class="homepage-features__container">
      <h2
        :id="$options.consts.ELEMENT_ID.FEATURES_SECTION"
        class="homepage-features__title title"
      >
        Features
      </h2>

      <ul class="homepage-features__items">
        <li v-for="item in items" class="homepage-features__item-wrapper">
          <homepage-feature-item :item="item" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import HomepageFeatureItem from '@/components/_sections/_homepage/HomepageFeatures/HomepageFeatureItem/index.vue'
import { ICON } from 'shared/AIcon/index.vue'
import { ELEMENT_ID } from 'enums/element-id'

export default {
  name: 'HomepageFeatures',
  components: { HomepageFeatureItem },
  consts: {
    ELEMENT_ID
  },
  data() {
    return {
      items: [
        {
          title: 'Real-Time',
          description:
            'Lightning fast updates delivering the latest market news and analyses instantly to your traders',
          icon: ICON.FEATURE_REAL_TIME
        },
        {
          title: 'Global',
          description:
            'Full coverage of all global markets, making sure your traders are informed no matter where they trade',
          icon: ICON.FEATURE_GLOBAL
        },
        {
          title: 'Comprehensive',
          description:
            'Extensive coverage of all trading instruments, providing in-depth analyses and data across the entire online trading spectrum',
          icon: ICON.FEATURE_COMPREHENSIVE
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~assets/scss/local/mixins/grid';

.homepage-features__wrapper {
  background: $c--white;

  .homepage-features__container {
    max-width: $desktop-container;

    $padding: (
      $above-desktop-xl: 96px $padding-x-desktop-full-hd 90px,
      $desktop-lg: 96px $padding-x-desktop-xl,
      $tablet: 64px $padding-x-tablet,
      $mobile: 32px $padding-x-mobile
    );

    @include setStyleByBreakpoint('padding', $padding);
  }

  .homepage-features__title {
    color: $c--coal-black;

    $margin-bottom: (
      $above-desktop-xl: 64px,
      $mobile: 32px
    );

    @include setStyleByBreakpoint('margin-bottom', $margin-bottom);
  }

  .homepage-features__items {
    $grid-setup: (
      $columnSetup: (
        $above-desktop-xl: repeat(3, minmax(0, auto)),
        $tablet: repeat(2, minmax(0, auto)),
        $mobile: minmax(0, auto)
      ),
      $columnGapSetup: (
        $above-desktop-xl: 30px
      ),
      $rowGapSetup: (
        $tablet: 32px,
        $mobile: 24px
      )
    );

    grid-auto-rows: min-content;

    @include gridBuilder($grid-setup);
  }
}
</style>
